import { Modal as Modal$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const Modal = createRemoteReactComponent(Modal$1, {
  fragmentProps: ['primaryAction', 'secondaryActions']
});

export { Modal };
